
import { Injectable } from '@angular/core';
import {ModuleRolePermissionList} from "../models/moduleRolePermissionList";
import {ResourcePermission} from "../resourcePermission";
import {ModuleRolePermissionService} from "./moduleRolePermission.service";
import {FuseNavigationService} from "../../../../@fuse/components/navigation/navigation.service";
import {ActivatedRoute, Router} from "@angular/router";
import {AccountService} from "../../services";

@Injectable({
    providedIn: 'root',
})
export class PermissionManagerService {
    private permissions: ResourcePermission[] = [];
    returnUrl: string;
    constructor(
        private moduleRolePermissionService: ModuleRolePermissionService,
        private _fuseNavigationService: FuseNavigationService,
        private route: ActivatedRoute,
        private router: Router,
    ) {
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/customers';

        if (this.returnUrl.length == 0 || this.returnUrl === '/') {
            this.returnUrl = '/customers';
        }
    }

    hasOnlyRole(role: string) {
        let roles = localStorage.getItem('role');
        return roles.includes(role);
    }

    isGranted(resource: string, permission: string) {
        let str = localStorage.getItem('permissions');
        let user = JSON.parse(localStorage.getItem('user'));

        if (!user) {
            return false;
        }

        let roles = user.roles;

        if (roles.includes('ROLE_SUPER_ADMIN')) {
            return true;
        }

        if (str) {
            this.permissions = JSON.parse(str);
        }

        for (const res of this.permissions) {
            if (resource == res.resource) {
                for (const perm of res.permissions) {
                    if (perm == permission || permission === 'ANY') {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    authAs(roles: string[]) {
        let role = 'UNKNOWN';

        if (roles.includes('ROLE_SUPER_ADMIN')) {
            role = 'ROLE_SUPER_ADMIN';
        } else if (roles.includes('ROLE_ADMIN')) {
            role = 'ROLE_ADMIN';
        } else if (roles.includes('ROLE_MANAGER')) {
            role = 'ROLE_MANAGER';
        } else if (roles.includes('ROLE_JUNIOR_MANAGER')) {
            role = 'ROLE_JUNIOR_MANAGER';
        } else if (roles.includes('ROLE_RECEPTIONIST')) {
            role = 'ROLE_RECEPTIONIST';
        } else if (roles.includes('ROLE_TRAINER')) {
            role = 'ROLE_TRAINER';
        } else if (roles.includes('ROLE_WORKER')) {
            role = 'ROLE_WORKER';
        }

        localStorage.setItem('role', role);

        let str = localStorage.getItem('permissions');

        if (!str) {
            let permissions = {};
            let translatedPermissions = [];
            for (let i = 0; i < roles.length; i++) {
                this.moduleRolePermissionService.getByRole(roles[i]).subscribe((response: ModuleRolePermissionList) => {
                    for (let i = 0; i < response.items.length; i++) {
                        if (typeof permissions[response.items[i].module.name] === 'undefined') {
                            permissions[response.items[i].module.name] = [];
                        }

                        if (!response.items[i].hasPermission) {
                            continue;
                        }

                        permissions[response.items[i].module.name].push(response.items[i].permission.name);
                    }

                    for (let module in permissions) {
                        translatedPermissions.push(new ResourcePermission(module, permissions[module]));
                    }

                    this.permissions = translatedPermissions;

                    localStorage.setItem('permissions', JSON.stringify(this.permissions));

                    this.router.navigate([this.returnUrl]).then(data => {
                        this.updateNavigation();
                    });

                }, error => {

                });
            }
        } else {
            this.permissions = JSON.parse(str);
        }
    }

    updateNavigation() {
        this._fuseNavigationService.updateNavigationItem('operators', {
            'hidden': !this.isGranted('Operators', 'ANY')
        });

        this._fuseNavigationService.updateNavigationItem('users', {
            'hidden': !this.isGranted('Users', 'ANY')
        });

        this._fuseNavigationService.updateNavigationItem('reports', {
            'hidden': !this.isGranted('Reports', 'ANY')
        });

        this._fuseNavigationService.updateNavigationItem('services', {
            'hidden': !this.isGranted('Services', 'ANY')
        });

        this._fuseNavigationService.updateNavigationItem('communication', {
            'hidden': !this.isGranted('Communication', 'ANY')
        });

        this._fuseNavigationService.updateNavigationItem('settings', {
            'hidden': !this.isGranted('Settings', 'ANY')
        });

        this._fuseNavigationService.updateNavigationItem('customers', {
            'hidden': !this.isGranted('Customers', 'ANY')
        });

        this._fuseNavigationService.updateNavigationItem('calendar', {
            'hidden': !this.isGranted('Calendar', 'ANY')
        });

        this._fuseNavigationService.updateNavigationItem('warehouse', {
            'hidden': !this.isGranted('Products', 'ANY')
        });

        this._fuseNavigationService.updateNavigationItem('notes', {
            'hidden': !this.isGranted('Notes', 'ANY')
        });

        if (this.hasOnlyRole('ROLE_TRAINER') || this.hasOnlyRole('ROLE_ADMIN')) {
            this._fuseNavigationService.updateNavigationItem('trainer-dashboard', {
                'hidden': false
            });
        }
    }
}
